export default {
  UPDATE_BREADCRUMB: 'UPDATE_BREADCRUMB'
};
